export interface IAuthStorage {
  set: (token: string) => Promise<void>;
  get: () => Promise<string | undefined>;
  remove: () => Promise<void>;
}

export const TOKEN_KEY = 'access_token';
